export const datacenters = {
  title: 'I Nostri Datacenter',
  subtitle: 'Strutture all\'avanguardia con connettività premium',
  milan: {
    name: 'Milan DC1',
    provider: 'Seeweb',
    address: 'Via Caldera 21',
    city: '20153 Milano (MI), Italia',
    features: {
      network: {
        title: 'Rete',
        description: 'Collegamenti multipli da 10G'
      },
      security: {
        title: 'Sicurezza',
        description: 'Protezione DDoS'
      },
      power: {
        title: 'Alimentazione',
        description: 'Alimentazione Ridondante'
      },
      monitoring: {
        title: 'Monitoraggio',
        description: 'Sicurezza 24/7'
      }
    }
  },
  falkenstein: {
    name: 'Falkenstein DC1',
    provider: 'Hetzner Online GmbH',
    address: 'Am Datacenter-Park 1',
    city: '08223 Falkenstein/Vogtland, Germania',
    features: {
      network: {
        title: 'Rete',
        description: 'SynthoNetwork 10G'
      },
      security: {
        title: 'Sicurezza',
        description: 'Protezione DDoS'
      },
      power: {
        title: 'Alimentazione',
        description: 'Alimentazione Ridondante'
      },
      storage: {
        title: 'Storage',
        description: 'Storage NVMe'
      }
    }
  }
};